import { render, staticRenderFns } from "./CandidateCourseHistoryItem.vue?vue&type=template&id=4bd2cbc2&scoped=true&lang=pug"
import script from "./CandidateCourseHistoryItem.vue?vue&type=script&lang=js"
export * from "./CandidateCourseHistoryItem.vue?vue&type=script&lang=js"
import style0 from "./CandidateCourseHistoryItem.vue?vue&type=style&index=0&id=4bd2cbc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd2cbc2",
  null
  
)

export default component.exports